<template>
    <kiosk-org-unit-details :teamId="props.teamId" :orgUnitId="props.orgUnitId">
        <div class="col-span-12 lg:col-span-10 flex flex-col w-full justify-center">
            <div class="max-w-(--breakpoint-sm) flex flex-col">
                <page-callout section="kiosk-org-unit-proforma-invoices" class="mb-4" />

                <page-loading v-if="loading || !billing"></page-loading>
                <template v-else>
                    <org-unit-proforma-invoices
                        v-if="orgUnit.is_billable"
                        :teamId="props.teamId"
                        :orgUnitId="orgUnit.id"
                        :paymentTermsDays="billing.payment_terms_days"
                    />
                </template>
            </div>
        </div>
    </kiosk-org-unit-details>
</template>

<script setup>
import OrgUnitProformaInvoices from '~/components/settings/billing/OrgUnitProformaInvoices.vue';
import PageLoading from '~/components/general/PageLoading.vue';
import PageCallout from '~/components/general/PageCallout.vue';
import KioskOrgUnitDetails from '~/components/kiosk/kiosk-org-units/details/KioskOrgUnitDetails.vue';
import { useOrgUnitDetails } from '~/components/kiosk/kiosk-org-units/composables/useOrgUnitDetails';

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
    orgUnitId: {
        type: Number,
        required: true,
    },
});

const { orgUnit, loading, billing, getBilling, onMountedOrgUnit } = useOrgUnitDetails();

onMountedOrgUnit(() => {
    getBilling();
});
</script>
